import axios from 'axios';
import { ApiResponse, PDFAnalysisData } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.banhcan.io.vn/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 120000, // 2 minutes timeout to match backend
});

export class ApiService {
  static async uploadAndAnalyzePDF(file: File): Promise<ApiResponse<PDFAnalysisData>> {
    const formData = new FormData();
    formData.append('pdf', file);

    try {
      const response = await api.post('/pdf/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return {
          success: false,
          error: error.response?.data?.error || error.message || 'Upload failed'
        };
      }
      return {
        success: false,
        error: 'Unknown error occurred'
      };
    }
  }

  static async getAnalysisHistory(): Promise<ApiResponse> {
    try {
      const response = await api.get('/pdf/history');
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return {
          success: false,
          error: error.response?.data?.error || error.message || 'Failed to get analysis history'
        };
      }
      return {
        success: false,
        error: 'Unknown error occurred'
      };
    }
  }

  static async getAnalysisStats(): Promise<ApiResponse> {
    try {
      const response = await api.get('/pdf/stats');
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return {
          success: false,
          error: error.response?.data?.error || error.message || 'Failed to get analysis stats'
        };
      }
      return {
        success: false,
        error: 'Unknown error occurred'
      };
    }
  }

  static async getAnalysisRecord(id: number): Promise<ApiResponse> {
    try {
      const response = await api.get(`/pdf/history/${id}`);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return {
          success: false,
          error: error.response?.data?.error || error.message || 'Failed to get analysis record'
        };
      }
      return {
        success: false,
        error: 'Unknown error occurred'
      };
    }
  }


  static async healthCheck(): Promise<ApiResponse> {
    try {
      const response = await api.get('/pdf/health');
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return {
          success: false,
          error: error.response?.data?.error || error.message || 'Health check failed'
        };
      }
      return {
        success: false,
        error: 'Unknown error occurred'
      };
    }
  }
}
